import {useSelector} from 'react-redux';

import {useMutation} from '@apollo/react-hooks';

import * as Session from 'nutshell-core/session/session-selectors';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetAircallIntegrationIsEnabledForUser as SetAircallIntegrationIsEnabledForUserMutation,
    SetAircallIntegrationIsEnabledForUserVariables,
    GetSessionUser as GetSessionUserQuery,
} from 'nutshell-graphql-types';

// @ts-expect-error
import {refreshUser} from '../../../../../user';
import GET_SESSION_USER from '../../../../core/graphql/queries/get-session-user.graphql';

import SET_AIRCALL_INTEGRATION_IS_ENABLED_FOR_USER from '../mutations/set-aircall-integration-is-enabled-for-user.graphql';

export const useSetAircallIntegrationIsEnabledForUser = (): {
    setAircallIntegrationIsEnabledForUser: (arg1: boolean) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const currentUserId = useSelector(Session.getSessionStateUserId);

    const [setAircallIntegrationIsEnabledForUserMutation, {loading, error}] = useMutation<
        SetAircallIntegrationIsEnabledForUserMutation,
        SetAircallIntegrationIsEnabledForUserVariables
    >(SET_AIRCALL_INTEGRATION_IS_ENABLED_FOR_USER, {
        update: (proxy, mutationResults) => {
            const loggedInUserCache: GetSessionUserQuery | null | undefined = proxy.readQuery({
                query: GET_SESSION_USER,
            });

            if (
                loggedInUserCache &&
                loggedInUserCache.loggedInUser &&
                loggedInUserCache.loggedInUser.phoneIntegrations &&
                mutationResults.data &&
                mutationResults.data.setAircallIntegrationIsEnabledForUser &&
                mutationResults.data.setAircallIntegrationIsEnabledForUser.integration
            ) {
                const updatedAircallIntegration =
                    mutationResults.data.setAircallIntegrationIsEnabledForUser.integration;

                const updatedIntegrations = loggedInUserCache.loggedInUser.phoneIntegrations.map(
                    (integration) => {
                        if (
                            integration.integrationType ===
                            updatedAircallIntegration.integrationType
                        ) {
                            return updatedAircallIntegration;
                        }

                        return integration;
                    }
                );

                proxy.writeQuery({
                    query: GET_SESSION_USER,
                    data: {
                        loggedInUser: {
                            ...loggedInUserCache.loggedInUser,
                            phoneIntegrations: updatedIntegrations,
                        },
                    },
                });
            }
        },
    });

    return {
        setAircallIntegrationIsEnabledForUser: (isEnabled: boolean) =>
            setAircallIntegrationIsEnabledForUserMutation({
                variables: {isEnabled},
            }).then((result) => {
                if (currentUserId) {
                    refreshUser(currentUserId);
                }

                return result;
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
